// extracted by mini-css-extract-plugin
export default {"reset-password":"reset-password_reset-password__X1zcb","col":"reset-password_col__f9Wav","container-form":"reset-password_container-form__wsFfU"};